import { accountPath } from '@/true-fsd/data/advertiser-account';
import {
  PollNewChannel,
  type PollNewChannelProps,
  useCreateAccountWithChannel,
} from '@/true-fsd/features/AwaitNewChannel';
import {
  AwaitNewChannelForm,
  type AwaitNewChannelFormProps,
} from '@/true-fsd/features/AwaitNewChannel/shared/AwaitNewChannelForm';
import { ButtonLink } from '@/true-fsd/shared/ui/ButtonLink';
import { FigmaWhiteLayout } from '@/true-fsd/shared/ui/FigmaLayout';
import { useCallback } from 'react';

export type CreateAccountWithChannelPageProps = {
  backLink: string;
};
export const CreateAccountWithChannelPage = ({
  backLink,
}: CreateAccountWithChannelPageProps) => {
  const hook = useCreateAccountWithChannel();

  const onCancel: PollNewChannelProps['onCancel'] = useCallback((navigate) => {
    void navigate('/');
  }, []);

  const onAccount: NonNullable<PollNewChannelProps['onAccount']> = (
    navigate,
    { createdAccount, invite },
  ) => {
    void navigate(accountPath(createdAccount, 'complete'), {
      state: invite,
    });
  };

  const RenderAwaitBack: AwaitNewChannelFormProps['RenderBack'] = useCallback(
    ({ navigate: __, ...props }) => (
      //to WorkspaceTypeSelect
      <ButtonLink {...props} to={backLink} />
    ),
    [backLink],
  );

  if (hook.channelRequest) {
    return (
      <PollNewChannel
        channelRequest={hook.channelRequest}
        RenderLayout={FigmaWhiteLayout}
        onAccount={onAccount}
        onCancel={onCancel}
      />
    );
  }
  return (
    <AwaitNewChannelForm
      mutateAsync={hook.mutateAsyncChannel}
      RenderLayout={FigmaWhiteLayout}
      RenderBack={RenderAwaitBack}
    />
  );
};
